import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import dogIcon from '@assets/images/home-category-dog.svg';
import catIcon from '@assets/images/home-category-cat.svg';
import Dogs from '@pages/home/dogs/Dogs';
import Cats from '@pages/home/cats/Cats';



enum CategoryEnum {
	dogs = 'dogs',
	cats = 'cats',
}



const Home = () => {

	const { t } = useTranslation('web');
	const [ category, setCategory ] = useState(CategoryEnum.dogs);


	return (
		<div className="app-page home-page">
			
			<div className='category-icons'>
				
				<div className="category-icon-container">
					<img
						src={dogIcon} alt='dog-category-icon'
						className={`category-icon disable-selection ${category === CategoryEnum.dogs ? 'active-category' : ''}`}
						draggable={false}
						onClick={() => setCategory(CategoryEnum.dogs)}
					/>
					<div className="category-label">{t('pages.home.dogCategoryLabel')}</div>
				</div>

				<div className="category-icon-container">
					<img
						src={catIcon} alt='cat-category-icon'
						className={`category-icon disable-selection ${category === CategoryEnum.cats ? 'active-category' : ''}`}
						draggable={false}
						onClick={() => setCategory(CategoryEnum.cats)}
					/>
					<div className="category-label">{t('pages.home.catCategoryLabel')}</div>
				</div>
			
			</div>

			{category === CategoryEnum.dogs &&
				<Dogs />}

			{category === CategoryEnum.cats &&
				<Cats />}

		</div>
	);
};

export default Home;